<template>
  <div class="tabs-view">
    <a-tabs
      v-if="panes.length !== 0"
      @change="changePage"
      v-model="activeKey"
      hide-add
      type="editable-card"
      @edit="onEdit">
      <a-tab-pane v-for="(pane, index) in panes" :closable="pane.closable" :key="pane.fullPath">
        <template #tab>
          <a-dropdown :trigger="['contextmenu']">
            <a-tooltip>
              <template slot="title">{{ pane.title }}</template>
              <div class="display-inline-block">
                <a-icon @click.stop="reloadPage(pane)" title="刷新" :class="['icon-sync ', {'hide': pane.fullPath !== activeKey}]" :type="pageLoading ? 'loading' : 'sync'" />
                {{ pane.title }}
              </div>
            </a-tooltip>
            <template v-slot:overlay>
              <a-menu class="user-select-none">
                <!-- <a-menu-divider/> -->
                <a-menu-item @click="closeLeft(pane, index)" key="3">
                  <a-icon type="vertical-right" />
                  关闭左侧
                </a-menu-item>
                <a-menu-item @click="closeRight(pane, index)" key="4">
                  <a-icon type="vertical-left" />
                  关闭右侧
                </a-menu-item>
                <!-- <a-menu-divider/> -->
                <a-menu-item @click="closeOther(pane, index)" key="5">
                  <a-icon type="close" />
                  关闭其他
                </a-menu-item>
                <a-menu-item @click="closeAll" key="6">
                  <a-icon type="stop" />
                  关闭全部
                </a-menu-item>
                <a-menu-item @click="reloadPage(pane)" :disabled="activeKey !== pane.fullPath" key="1">
                  <a-icon type="sync" />
                  刷新
                </a-menu-item>
                <!-- <a-menu-item @click="removeTab(pane, index)" key="2">
                  <a-icon type="close" />
                  关闭
                </a-menu-item> -->
              </a-menu>
            </template>
          </a-dropdown>
        </template>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
export default {
  name: 'TabsView',
  data () {
    const panes = [
      { title: '工作台', key: '/dashboard/workplace', fullPath: '/dashboard/workplace', closable: false }
    ]
    return {
      activeKey: panes[0].key,
      panes,
      newTabIndex: 0,
      pageLoading: false
    }
  },
  created () {
    this.loadCachedTabs()
    this.handleRouteChange(this.$route)
    this.event.$on("close-current-page", (res) => {
      const index = this.panes.findIndex(item => {
        return item.fullPath === this.activeKey
      })
      this.removeTab(this.pane, index)
    });
    this.event.$on("close-all-page", (res) => {
      this.$emit('close-tabs', this.panes.map(item => item.fullPath))
      // 删除数组全部元素->数组置空
      this.panes = [{
        'title': "工作台",
        'fullPath': "/dashboard/workplace",
        'key': "/dashboard/workplace"
      }];
      this.activeKey = '/dashboard/workplace'
      this.$router.push({
        path: '/dashboard/workplace'
      });
      this.$store.commit('clearCashHistory') // 清除之前设置的缓存
      this.$store.commit('clearCacheData') // 清除快码的请求缓存
    });
    // 关闭某类页面并打开某个页面
    this.event.$on("close-and-open-page", (res) => {
      const indexesToRemove = [];
      if (typeof res.closePath === "string") {
        this.panes.forEach((item, itemIndex) => {
          if (item.fullPath.split('?')[0] === res.closePath) {
            indexesToRemove.push(itemIndex);
          }
        })
      } else if (Array.isArray(res.closePath)) {
        res.closePath.forEach(closePathItem => {
          this.panes.forEach((item, itemIndex) => {
            if (item.fullPath.split('?')[0] === closePathItem) {
              indexesToRemove.push(itemIndex);
            }
          })
        })
      }
      indexesToRemove.sort((a, b) => b - a); // 从大到小排序，避免前面元素被删除后影响后面元素的索引
      const removedPanes = indexesToRemove.map(index => this.panes[index])
      indexesToRemove.forEach(index => {
        this.panes.splice(index, 1);
      });
      this.setNoAliveRouter(removedPanes)
      this.$router.push(res.openPath)
    });
  },
  mounted() {
    this.$EventBus.$on('closeTabPage', this.remove);
  },
  beforeDestroy() {
    this.$EventBus.$off('closeTabPage', this.remove);
  },
  // 监听,当路由发生变化的时候执行
  watch: {
    $route: {
      handler: 'handleRouteChange',
      // 深度观察监听
      deep: true
      // immediate: true
    }
  },
  methods: {
    handleRouteChange (val) {
      const title = val.meta.title
      const fullPath = val.fullPath
      const routerObj = Object.assign({
        'title': title,
        'fullPath': fullPath,
        'key': fullPath,
        'name': val.name
      })
      // 先判断标签路由中是否已经存在相同的,如果存在相同的跳转后不push
      let flag = true
      this.panes.forEach(item => {
        if (item.fullPath === fullPath) {
          flag = false
        }
      })
      if (flag) {
        this.panes.push(routerObj)
      }
      sessionStorage.setItem(
        'tabs.data',
        JSON.stringify(this.panes)
      );
      // console.log(12, this.panes)
      this.activeKey = fullPath
    },
    remove (targetKey) {
      let index = -1
      this.panes.forEach((pane, i) => {
        if (pane.key === targetKey) {
          index = i
        }
      })
      if (this.panes[index]?.name) {
        this.setNoAliveRouter([this.panes[index]])
        // this.$store.commit('setNoAliveRouter', this.panes[index].name)
      }
      if (index !== -1) {
        this.$store.commit('delItemCache', this.panes[index]?.fullPath)
        this.panes.splice(index, 1)
        if (this.panes.length === 0) {
          this.$router.push({
            path: '/dashboard/workplace'
          })
        }
        const prevItem = this.panes[index - 1]
        if (prevItem) {
          this.activeKey = prevItem.fullPath
          this.$router.push({
            path: prevItem.fullPath
          })
        }
        const nextItem = this.panes[index + 1]
        if (nextItem) {
          this.activeKey = nextItem.fullPath
          this.$router.push({
            path: nextItem.fullPath
          })
        }
      }
    },
    onEdit (targetKey, action) {
      this[action](targetKey)
    },
    changePage (key) {
      this.activeKey = key
      this.$router.push({ path: key })
    },
    // 刷新页面
    reloadPage (pane) {
      this.pageLoading = true;
      setTimeout((val) => {
        this.pageLoading = false;
      }, 500)
      this.$emit('reload', pane.fullPath)
    },
    // 关闭当前
    removeTab (pane, index) {
      if (index > -1 && this.panes[index]?.fullPath) {
        this.$store.commit('delItemCache', this.panes[index]?.fullPath)
      }
      // 判断如果当前是最后一个元素了,就跳转到工作台
      const list = this.panes.splice(index, 1)
      this.setNoAliveRouter(list)
      if (this.panes.length === 0) {
        this.$router.push({
          path: '/dashboard/workplace'
        })
      }
      const prevItem = this.panes[index - 1]
      if (prevItem) {
        this.activeKey = prevItem.fullPath
        this.$router.push({
          path: prevItem.fullPath
        })
      }
      const nextItem = this.panes[index + 1]
      if (nextItem) {
        this.activeKey = nextItem.fullPath
        this.$router.push({
          path: nextItem.fullPath
        })
      }
    },
    // 关闭其他
    closeOther (pane, index) {
      const delIndex = index + 1
      // 删除其所有右侧元素
      const list1 = this.panes.splice(delIndex, this.panes.length - delIndex)
      this.setNoAliveRouter(list1)
      // 删除其所有左侧元素
      const list2 = this.panes.splice(0, index)
      this.setNoAliveRouter(list2)
    },
    // 关闭左侧
    closeLeft (pane, index) {
      const list = this.panes.splice(0, index)
      this.setNoAliveRouter(list)
    },
    // 关闭右侧
    closeRight (pane, index) {
      const delIndex = index + 1
      const list = this.panes.splice(delIndex, this.panes.length - delIndex)
      this.setNoAliveRouter(list)
    },
    // 关闭全部
    closeAll () {
      // this.event.$emit("clean-keep-alive-cache"); // 清除缓存
      this.setNoAliveRouter(this.panes)
      // 删除数组全部元素->数组置空
      this.panes = [{
        'title': "工作台",
        'fullPath': "/dashboard/workplace",
        'key': "/dashboard/workplace"
      }];
      this.activeKey = '/dashboard/workplace'
      this.$router.push({
        path: '/dashboard/workplace'
      })
      this.$store.commit('clearCashHistory')
    },
    // 批量设置不缓存页面
    setNoAliveRouter (list) {
      if (list?.length > 0) {
        // 删除代码缓存的查询条件
        const fullPaths = list.map(item => item?.fullPath)
        this.$store.commit('batchDelCache', fullPaths)
        this.$emit('close-tabs', fullPaths)
        // 删除keepalive缓存
        const noAliveList = []
        list.forEach(v => {
          if(v?.name) { noAliveList.push(v.name) }
        })
        // this.event.$emit("batch-clean-keep-alive-cache", noAliveList); // 清除缓存
        this.$store.commit('setNoAliveRouterList', noAliveList)
      }
    },
    loadCachedTabs () {
      const cachedTabsStr = sessionStorage.getItem('tabs.data');
      if (cachedTabsStr) {
        try {
          const cachedTabs = JSON.parse(cachedTabsStr);
          if (cachedTabs.length > 0) {
            this.panes = cachedTabs;
          }
        } catch (e) {
          console.warn("failed to load cached tabs, got exception:", e);
        }
      }
    }
  }
}
</script>

<style scoped lang="less">
.icon-sync{
  margin-right: 0 !important;
  margin-left: 0;
  color: #52b4ff;
  transition: all 0.3s ease-in-out;
  &:hover{
    color: #007ef9;
  }
  font-size: 14px;
  &.hide{
    font-size: 0;
  }
}
/deep/.ant-dropdown-menu-item{
  padding: 8px 14px;
}
.display-inline-block {
  display: inline-block
}
.user-select-none {
  user-select: none
}
</style>
